import { GreenlightLogo } from '../components/GreenlightLogo';

export default function LoginPage() {
  return (
    <div className="flex min-h-screen">
      {/* ── Left — branding panel ─────────────────────────────────── */}
      <aside className="hidden lg:flex lg:w-[44%] xl:w-[40%] flex-col justify-between bg-[#0d1117] px-12 py-10 relative overflow-hidden select-none">
        {/* Subtle background grid */}
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,0.028) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.028) 1px, transparent 1px)',
            backgroundSize: '40px 40px',
          }}
        />
        {/* Green radial glow in bottom-left */}
        <div
          className="pointer-events-none absolute -bottom-32 -left-32 w-96 h-96 rounded-full opacity-20"
          style={{
            background: 'radial-gradient(circle, #16a34a 0%, transparent 70%)',
          }}
        />

        {/* Logo + wordmark */}
        <div className="relative z-10 flex items-center gap-3">
          <GreenlightLogo size={38} />
          <span className="text-white text-xl font-semibold tracking-tight">
            Greenlight
          </span>
        </div>

        <div />

        {/* Footer */}
        <p className="relative z-10 text-xs text-slate-600">
          © {new Date().getFullYear()} IVN — internal tool
        </p>
      </aside>

      {/* ── Right — login form ────────────────────────────────────── */}
      <main className="flex flex-1 flex-col items-center justify-center bg-white px-6">
        {/* Mobile-only logo */}
        <div className="mb-8 flex flex-col items-center gap-3 lg:hidden">
          <GreenlightLogo size={52} />
          <span className="text-xl font-semibold tracking-tight text-gray-900">Greenlight</span>
        </div>

        <div className="w-full max-w-sm">
          {/* Card */}
          <div className="rounded-2xl border border-gray-100 bg-white px-8 py-9 shadow-[0_4px_32px_-4px_rgba(0,0,0,0.10)]">
            {/* Desktop logo inside card */}
            <div className="mb-6 hidden lg:flex flex-col items-center gap-2">
              <GreenlightLogo size={48} />
            </div>

            <h1 className="text-center text-xl font-semibold text-gray-900 tracking-tight">
              Welcome back
            </h1>
            <p className="mt-1 mb-7 text-center text-sm text-gray-400">
              Sign in with your authorised Google account to continue
            </p>

            <a
              href="/auth/google/login"
              className="group flex w-full items-center justify-center gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm font-medium text-gray-700 shadow-sm transition-all duration-150 hover:border-gray-300 hover:bg-gray-50 hover:shadow-md active:scale-[0.98]"
            >
              <GoogleIcon />
              Sign in with Google
            </a>

            <div className="mt-6 flex items-center gap-3">
              <div className="h-px flex-1 bg-gray-100" />
              <span className="text-[11px] text-gray-300 uppercase tracking-wider">or</span>
              <div className="h-px flex-1 bg-gray-100" />
            </div>

            <p className="mt-4 text-center text-xs text-gray-400 leading-relaxed">
              Access is restricted to authorised IVN employees.
              <br />Contact your administrator if you need access.
            </p>
          </div>

          {/* Below-card tagline */}
          <p className="mt-5 text-center text-xs text-gray-300">
            Greenlight · Price Intelligence Platform
          </p>
        </div>
      </main>
    </div>
  );
}

// ── Sub-components ────────────────────────────────────────────────────────────

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" className="shrink-0">
      <path
        d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
        fill="#4285F4"
      />
      <path
        d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"
        fill="#34A853"
      />
      <path
        d="M3.964 10.707A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.707V4.961H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.039l3.007-2.332z"
        fill="#FBBC05"
      />
      <path
        d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.961L3.964 7.293C4.672 5.163 6.656 3.58 9 3.58z"
        fill="#EA4335"
      />
    </svg>
  );
}
